let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bnitc")).then(() => parcelRequire('7sUdD'));